document.addEventListener("DOMContentLoaded", function() {
  const navParent = document.getElementById("collectionNavParent");
  const shopAllNav = document.getElementById("shopAllNav");
  const mainHeader = document.querySelector(".mainHeader");

  // Smooth horizontal scroll on wheel for image nav
  if (shopAllNav) {
    let rafId = null;
    let targetScroll = 0;

    function animateScroll() {
      const diff = targetScroll - shopAllNav.scrollLeft;
      if (Math.abs(diff) < 0.5) {
        shopAllNav.scrollLeft = targetScroll;
        rafId = null;
        return;
      }
      shopAllNav.scrollLeft += diff * 0.18;
      rafId = requestAnimationFrame(animateScroll);
    }

    shopAllNav.addEventListener("wheel", function(e) {
      if (window.innerWidth <= 1260) return;
      const maxScroll = shopAllNav.scrollWidth - shopAllNav.clientWidth;
      if (maxScroll <= 0) return;

      e.preventDefault();

      let delta = e.deltaY;
      if (e.deltaMode === 1) delta *= 40;
      if (e.deltaMode === 2) delta *= shopAllNav.clientWidth;

      if (!rafId) targetScroll = shopAllNav.scrollLeft;
      targetScroll = Math.max(0, Math.min(maxScroll, targetScroll + delta));
      if (!rafId) rafId = requestAnimationFrame(animateScroll);
    }, { passive: false });
  }

  // Sticky top follows the visible header (published every frame by header-scroll.js)
  if (navParent && mainHeader) {
    navParent.style.top = "var(--hdr-visible, 0px)";
  }

  // Dropdown toggle for sticky breadcrumb bar
  const stickyBar = document.getElementById("collectionStickyBar");
  if (stickyBar) {
    const trigger = stickyBar.querySelector(".breadcrumb-dropdown-trigger");
    const dropdown = stickyBar.querySelector(".breadcrumb-dropdown");

    if (trigger && dropdown) {
      trigger.addEventListener("click", () => {
        const isOpen = dropdown.classList.toggle("is-open");
        trigger.setAttribute("aria-expanded", isOpen);
      });

      document.addEventListener("click", (e) => {
        if (!stickyBar.contains(e.target)) {
          dropdown.classList.remove("is-open");
          trigger.setAttribute("aria-expanded", "false");
        }
      });
    }
  }
});
